<template>
  <div class="benefitactivities">
    <header-view curr="6"></header-view>
    <div class="body">

	  <div class="toptitle">
	  		<div class="left_c">
				<div class="redcon"></div>
				<span>公益活动</span>
			</div>
			<div class="right_c">
				<div class="searchcon">
					 <input class="inputa" placeholder="请输入" v-model="searchv"
					  @input="changeinput"/>
					 <img class="imgcon" src="../assets/searchimg.png" alt="" 
					 @click="changeinput"/>
				</div>
			</div>
	  </div>
	  
      <div class="centent">
       <!-- <div v-for="(item, index) in list">
		  <div @click="toDatail(index,item)">
				<div class="item hand">
				  <div class="title " :title="item.titile">{{ item.titile }}</div>
				  <div class="subtitle">
					<div class="left">
						<span style="margin-right: 1rem;">作者：{{ item.createBy_dictText || ''}}</span>
						<span>阅读：{{ item.views || '0'}}次</span>
					</div>
					<div class="right">{{ item.sendTime }}</div>
				  </div>
				</div>		
		  </div>
        </div> -->
		
		<div class="col_gy">
			<div class="colbcar" v-for="(item,index) in list" @click="toDatail(index,item)">
				<div class="img_con">
					<img :src="getFileAccessHttpUrl(item.breviaryMap)" alt="" />
				</div>
				
				<div>
					<div class="inform_con">
						<div class="title">
							{{item.title || ''}}
						</div>
						<div class="cencon">
							{{gethypertext(item.content)}}
						</div>
						<div class="btncon">
							<div class="btndetail">查看详情</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		
      </div>
	  
      <zhini-pagination
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
	  
    </div>
  </div>
</template>

<script>
import zhiniPagination from "../components/zhini-pagination.vue";
export default {
  name: "benefitactivities",
  components: {
    zhiniPagination
  },
  data: function() {
    return {
      list: "",
      pageNo: 1,
      pageSize: 9,
      totalPage: 0,
      url: "",
	  
	  typesign:0,
	  searchv:"",
	  
    };
  },
  created() {	  
    this.init();	
  },
  watch:{
  		$route(){
  		      this.typesign = this.$route.query.type
  		},
  	    typesign() {
  	      	this.typesign = this.$route.query.type
  			this.init()
  	    },
  },
  methods: {
	//搜索
	changeinput(){
		this.init()  
	},
	
	//过滤富文本
	gethypertext(str){
		  if(str == null){
				return "";
		  }
		  var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
		              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
		  str = str.substring(0,50);
		  return str;
	},
	
    toDatail(indexsign,item){
		this.$router.push({ path: '/benefitactivitiesdetail', query: {index:indexsign,id:item.id} });
	},
 
    init() {
      var that = this;
	  var val = "sendTime"
	  if(this.$route.query.type == 2){
		  val = "views"
	  }
      this.httpGet("web/info/list", {
			// sort:val,
			infoType:"0",
			pageNo: this.pageNo,
			pageSize: this.pageSize,
			title:this.searchv
      }).then(res => {
			that.list = res.result.records;
			that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;	
		
      this.pageNo = e;
      this.init();
    }
  },
  mounted() {}
};
</script>
<style scoped="scoped" lang="scss">
// ::-webkit-scrollbar {
//             width: 0px;
//         }
.benefitactivities {
  // background: #f4f5f9;
  width: 100%;
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    min-height: 10rem;
	// height: 100%;
    background: #ffffff;
    margin: 2.22rem auto 0;
    padding: 0 0.7rem;
    overflow: hidden;
    .centent {
      width: 10.22rem;
      margin: 0 auto;
      // min-height: 5rem;
      // height:5rem;
      // overflow:auto;
	  
	  .col_gy{
	  	// height: 5rem;
	  	display: flex;
	  	align-items: center;
		// justify-content: space-around;
		flex-wrap: wrap;
	  	margin-top: 0.2rem;
	  	margin-left: 0.1rem;
	  	// border: 1px solid red;
	  	.colbcar{
			cursor: pointer;
	  		width: 30%;
			margin-right: 0.3rem;
			margin-bottom: 0.3rem;
	  		height: 4.23rem;
	  		background: #F8F8F8;
	  		border: 1px solid #F1F1F1;
	  		// opacity: 0.3;
	  		.img_con{
	  			width: 100%;
	  			height: 1.92rem;
	  			img{
	  				width: 100%;
	  				height: 100%;
	  			}
	  		}
	  		
	  		.inform_con{
	  			margin-left: 0.25rem;
	  			margin-right: 0.25rem;
	  			// height: 2rem;
	  			// border: 1px solid red;
	  			.title{
	  				font-size: 0.18rem;
	  				font-weight: 400;
	  				color: #333333;
	  				height: 0.6rem;
	  				line-height: 0.6rem;
	  			}
	  			.cencon{
	  				font-size: 0.14rem;
	  				font-weight: 400;
	  				color: #666666;
				    height: 1rem;
	  			}
	  			.btncon{
	  				height: 0.7rem;
	  				display: flex;
	  				align-items: center;
	  				justify-content: center;
	  				.btndetail{
	  					width: 0.96rem;
	  					height: 0.3rem;
	  					line-height: 0.3rem;
	  					text-align: center;
	  					border: 1px solid #F80509;
	  					border-radius: 0.15rem;
	  					font-size: 0.14rem;
	  					font-weight: 400;
	  					color: #E41E15;
						cursor: pointer;
	  				}
	  			}
	  			
	  		}
	  	}					
	  }
	  
	  
    }
	
    .zhini-pagination {
      // position: absolute;
      // bottom: 0.55rem;
	  position: relative;
	  top:0;
      width: 100%;
      left: 0;
    }
	
	.toptitle{
		height: 0.6rem;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 0.05rem;
				height: 0.2rem;
				background: #E70012;
				margin-right: 0.2rem;
			}
			font-size: 0.18rem;
			font-weight: 400;
			color: #E61F26;
		}
		.right_c{
			// margin-right: 0.2rem;
			.searchcon{
				height: 0.4rem;
				line-height: 0.4rem;
				width: 2.68rem;
				background: #F1F1F1;
				border-radius: 0.15rem;
				padding-left: 0.2rem;
				padding-right: 0.2rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.inputa{
					font-size: 0.14rem;
				}
				.imgcon{
					height:0.18rem;
					width: 0.18rem;
				}
			}
		}
	}
	
	
  }
}
</style>
